/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./LassoAPI',
	'./LassoAPISpec',
	'../../../visualizations/interactions/lassoSelect/LassoSelectView'
], function(StringResources, APIFactory, LassoAPI, LassoAPISpec, DefaultLassoSelectView) {

	class Lasso extends LassoAPISpec {
		constructor({ features }) {
			super();
			this._providers = [];
			this.features = features;
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [LassoAPI]);
			}
			return this._api;
		}

		registerProvider(provider){
			if(typeof provider.getLassoContribution !== 'function' ){
				throw new Error('Registered lasso provider doesn"t have a getLassoContribution function');
			}
			return this._providers.push(provider);
		}

		getContributions(){
			let contributions = [{
				id: 'lw-lasso-select',
				name: 'lasso',
				icon: 'visualizations-marquee_16',
				label: StringResources.get('toolbarActionLassoSelect'),
				module: DefaultLassoSelectView
			}];

			this._providers.forEach(provider => contributions.push( ...provider.getLassoContribution() ));
			return contributions;
		}

		toggleLassoSelect(lassoViewId){
			const content = this.features.Canvas.getSelectedContentList()[0];
			const visualizationGesture = content && content.getFeature('VisualizationGesture');
			if(visualizationGesture){
				const lassoState = visualizationGesture.getLassoSelectState();
				visualizationGesture.setLassoSelectState(!lassoState, lassoViewId);
				const toolbar = content.getFeature('Toolbar.internal');
				if(toolbar){
					toolbar.refresh();
				}
			}
		}
	}
	return Lasso;
});
